module.exports = __webpack_public_path__ + "images/emoji/herb.fe329e8bdbe5fecc686b.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/herb.png
// module id = KsM/
// module chunks = 2